<button
  mat-stroked-button
  [matMenuTriggerFor]="menu"
  [disabled]="disabled"
  class="value-props-dropdown-btn"
  (menuOpened)="menuOpen=true;"
  (menuClosed)="menuOpen=false;"
>
  <span>Add financing benefit</span>
  <mat-icon class="arrow-button-icon" iconPositionEnd>arrow_drop_down</mat-icon>
</button>

<mat-menu #menu="matMenu" class="value-props-dropdown">
  <div *ngIf="isLoading; else options" class="tw-m-4 d-flex justify-content-center tw-w-56 tw-my-8">
    <mat-spinner diameter="24" class="loading-value-props"></mat-spinner>
    <div class="loading-text">Loading...</div>
  </div>

  <ng-template #options>
    <div *ngIf="!isEmpty; else empty" class="-tw-mt-2">
      <div class="tw-px-4 tw-pt-4 tw-pb-2 tw-sticky tw-top-0 tw-z-10 tw-bg-white">
        @if( valueProps?.length ) {
          <button mat-stroked-button class="tw-w-full tw-font-semibold" (click)="onAddAll()">
            <mat-icon>add</mat-icon>
            Add all benefits
          </button>
        } @else {
          <button mat-stroked-button class="tw-w-full tw-font-semibold tw-mb-10" (click)="onRemoveAll()">
           <mat-icon>remove</mat-icon>
           Remove all benefits
         </button>
        }
      </div>
      <div *ngIf="valueProps?.length" class="value-prop-items">
        <button
          *ngFor="let valueProp of valueProps; trackBy: valuePropId"
          mat-menu-item
          class="value-prop-option-btn"
          [@listAnimation]="menuOpen"
          (click)="onSelect(valueProp, $event)"
        >
          <mat-icon>add</mat-icon>
          <span class="tw-block tw-text-sm tw-mt-1 tw-mb-1">{{ valueProp.title }}</span>
          <span class="tw-block tw-text-xs tw-text-gray-500 tw-mb-1">{{ valueProp.description }}</span>
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #empty>
    <div class="tw-m-4 tw-text-center tw-w-56">
      No options available.
    </div>
  </ng-template>
</mat-menu>
